// extracted by mini-css-extract-plugin
export default {"sectionIntro":"PricingSection-module__sectionIntro--poEIh"};